<template>
  <div>
    <modal id="message-modal">
      <h5 slot="header"><strong>{{ selectedMessage.subject }}</strong></h5>
      <div slot="body">
        <div>
          Primaoc: 
          <button class="btn btn-link btn-decoration-none shadow-none" @click.stop.prevent="goToUser(selectedMessage.receiverId)">
            {{ selectedMessage.receiver }}
          </button>
          <hr />
        </div>
        <div v-html="selectedMessage.content"></div>
      </div>
      <div slot="footer">
        <div class="row">
          <div class="col-md-12 text-end">
            <button type="button" class="btn btn-primary px-4" data-bs-dismiss="modal">
              Zatvori
            </button>
          </div>
        </div>
      </div>
    </modal>
    <div class="row">
      <div class="col">
        <div class="card card-modern">
          <div class="card-body">
            <div class="datatables-header-footer-wrapper mt-2">
              <div class="datatable-header">
                <div class="row align-items-center mb-3">
                  <div class="col-12 col-lg-auto mb-3">
                    <router-link
                      :to="{ name: 'AddSystemMessage' }"
                      class="btn btn-primary btn-md font-weight-semibold btn-py-2 px-4"
                    >
                      + {{ translations.addMessage }}
                    </router-link>
                  </div>
                  <div class="col-8 col-lg-auto ms-auto ml-auto mb-3 mb-lg-0">
                  </div>
                  <div class="col-4 col-lg-auto ps-lg-1 mb-3 mb-lg-0">
                    <div
                      class="d-flex align-items-lg-center flex-column flex-lg-row"
                    >
                      <label class="ws-nowrap me-3 mb-0">Show:</label>
                      <select
                        class="form-control select-style-1 results-per-page"
                        name="results-per-page"
                        v-model="searchConfig.pageSize"
                        @change="changePageSize(searchConfig.pageSize)"
                      >
                        <option
                          :value="page"
                          v-for="page in pageSizeList"
                          :key="page"
                        >
                          {{ page }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="col-12 col-lg-auto ps-lg-1">
                    <div
                      class="search search-style-1 search-style-1-lg mx-lg-auto"
                    >
                      <div class="input-group">
                        <input
                          type="text"
                          class="search-term form-control"
                          placeholder="Search"
                          v-model="searchField"
                          @input="debounceInput"
                        />
                        <button class="btn btn-default" type="submit">
                          <i class="bx bx-search"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                v-if="list.length > 0"
                id="datatable-ecommerce-list_wrapper"
                class="dataTables_wrapper dt-bootstrap5 no-footer"
              >
                <div class="row justify-content-between">
                  <div class="col-auto"></div>
                  <div class="col-auto"></div>
                </div>
                <div class="table-responsive">
                  <table
                    class="table table-ecommerce-simple table-striped mb-0 dataTable no-footer"
                    id="datatable-ecommerce-list"
                    style="min-width: 550px"
                    role="grid"
                    aria-describedby="datatable-ecommerce-list_info"
                  >
                    <thead>
                      <tr role="row">
                        <th
                          width="3%"
                          class="sorting_disabled"
                          rowspan="1"
                          colspan="1"
                          aria-label=""
                          style="width: 17px"
                        >
                          <input
                            type="checkbox"
                            class="select-all checkbox-style-1 p-relative top-2"
                            v-model="selectAll"
                          />
                        </th>
                        <th
                          class="sorting"
                          tabindex="0"
                          aria-controls="datatable-ecommerce-list"
                          rowspan="1"
                          colspan="1"
                        >
                          Rbr
                        </th>
                        <th
                          class="sorting"
                          tabindex="0"
                          aria-controls="datatable-ecommerce-list"
                          rowspan="1"
                          colspan="1"
                        >
                          Naslov
                        </th>
                        <th
                          class="sorting"
                          tabindex="0"
                          aria-controls="datatable-ecommerce-list"
                          rowspan="1"
                          colspan="1"
                        >
                          Datum
                        </th>
                        <th
                          class="sorting"
                          tabindex="0"
                          aria-controls="datatable-ecommerce-list"
                          rowspan="1"
                          colspan="1"
                        >
                          Sadržaj
                        </th>
                        <th
                          class="sorting"
                          tabindex="0"
                          aria-controls="datatable-ecommerce-list"
                          rowspan="1"
                          colspan="1"
                          aria-label="Parent Category: activate to sort column ascending"
                        >
                          Pošiljaoc
                        </th>
                        <th
                          class="sorting"
                          tabindex="0"
                          aria-controls="datatable-ecommerce-list"
                          rowspan="1"
                          colspan="1"
                          aria-label="Parent Category: activate to sort column ascending"
                        >
                          Primaoc
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(item, index) in list"
                        :key="item.id"
                        :class="{ odd: index % 2 === 0, even: index % 2 !== 0 }"
                      >
                        <td width="30">
                          <input
                            type="checkbox"
                            class="checkbox-style-1 p-relative top-2"
                            :value="item.id"
                            v-model="selected"
                            @click.stop
                          />
                        </td>

                        <td>
                          <router-link
                            :to="{
                              name: 'ViewMessage',
                              params: { id: item.id },
                            }"
                          >
                            <strong>{{
                              (pager.currentPage - 1) * searchConfig.pageSize +
                              index +
                              1
                            }}</strong>
                          </router-link>
                        </td>

                        <td>
                          <!-- <router-link
                            :to="{
                              name: 'ViewMessage',
                              params: { id: item.id },
                            }"
                          >
                            {{ item.subject }}
                          </router-link> -->
                          <a href="#" @click.prevent="showMessagePreview(item)">{{ item.subject }}</a>
                        </td>

                        <td>
                          {{ formatDate(item.createdDate) }}
                        </td>

                        <td class="text-hidden" :title="item.content">
                          {{ item.content || "N/A" }}
                        </td>

                        <td>
                          {{ item.sender }}
                        </td>

                        <td>
                          {{ item.receiver }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div v-else>
                <div class="alert alert-info" role="alert">
                  {{ translations.noRecords }}
                  <a class="alert-link" @click.prevent="resetFilters">{{
                    translations.resetFilters
                  }}</a
                  >.
                </div>
              </div>
              <hr class="solid mt-5 opacity-4" />
              <div class="datatable-footer">
                <div
                  class="row align-items-center justify-content-between mt-3"
                >
                  <div class="col-md-auto order-1 mb-3 mb-lg-0">
                    <div class="d-flex align-items-stretch">
                      <div
                        class="d-grid gap-3 d-md-flex justify-content-md-end me-4"
                      >
                        <select
                          class="form-control select-style-1 bulk-action"
                          name="bulk-action"
                          v-model="bulkAction"
                          style="min-width: 170px"
                        >
                          <option value="bulkAction">Bulk Actions</option>
                          <option value="delete">Delete</option>
                        </select>

                        <button
                          type="button"
                          data-bs-toggle="modal"
                          data-bs-target="#delete-modal"
                          class="bulk-action-apply text-color-dark text-3 btn btn-light border btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1"
                        >
                          {{ translations.apply }}
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="row row-gutter-sm justify-content-between mt-4">
                    <pagination :action="actionName" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- end: page -->
    </div>
    <modal id="delete-modal">
      <h5 slot="header">
        <strong>{{ translations.deleteSelected }}</strong>
      </h5>
      <div slot="body">
        <span v-html="deleteModalText"> </span>
      </div>
      <div slot="footer">
        <div class="row">
          <div class="col-md-12 text-end">
            <button
              type="button"
              class="btn btn-primary px-4 mx-2"
              @click.prevent.stop="handleBulkAction"
              data-bs-dismiss="modal"
            >
              {{ translations.yes }}
            </button>
            <button
              type="button"
              class="btn btn-default px-4"
              data-bs-dismiss="modal"
            >
              {{ translations.no }}
            </button>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import { format } from "date-fns";
import { translations, pager } from "@/mixins";
import Pagination from "@/components/shared/Pagination.vue";
import Modal from "@/components/shared/modal/Modal.vue";

export default {
  name: 'SystemMessages',
  mixins: [translations, pager],
  components: { Pagination, Modal },
  data() {
    return {
      actionName: 'getSystemMessagesAsAdmin',
      deleteActionName: 'deleteSystemMessages',
      bulkActionName: 'deleteSystemMessages',
      selectedMessage: {},
    };
  },
  computed: {
    list() {
      return this.$store.getters.getSystemMessagesAsAdmin;
    },
    deleteModalText() {
      return this.translations.areYouSureSelected;
    },
  },
  methods: {
    formatDate(date) {
      return format(new Date(date), 'dd.MM.yyyy hh:mm');
    },
    showMessagePreview(message) {
      this.selectedMessage = message;
      $('#message-modal').modal('show');
    },
    goToUser(id) {
      $('#message-modal').modal('hide');
      this.$router.push({ name: 'EditUser', params: { id } });
    },
  },
  mounted() {
    this.$store.dispatch(this.actionName, this.searchConfig);
  },
};
</script>

<style lang="scss">
.btn-decoration-none {
  text-decoration: none;
  outline: none;
}
</style>